// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2eOQn","itemTitle":"ClientEmergencyInfo_itemTitle__1QxRJ","itemText":"ClientEmergencyInfo_itemText__2KclG"};